module.exports = __webpack_public_path__ + "react/assets/TriggeringModal/Preview/Banner/Device/mobileAndroid/BOTTOM.png";